import i18n from "@/common/i18n";
import Layout from '@/layout/embedLayout';
const router = [{
  path: '/embed/AI',
  component: Layout,
  meta: {
    auth: true,
    title: i18n.t("lang.k_006001"),
    name: 'AI'
  },
  hide: true,
  children: [{
    path: 'chat/list',
    component: () => import('@/views/AIModule/chat/list'),
    meta: {
      auth: true,
      title: i18n.t("lang.k_006002"),
      name: 'AIChatList',
      showOneChildren: true
    }
  }, {
    path: 'chat/create',
    component: () => import('@/views/AIModule/chat/edit'),
    meta: {
      auth: true,
      title: i18n.t("lang.k_006003"),
      level: 2,
      name: 'AIChatCreate'
    },
    hidden: true
  }, {
    path: 'chat/edit/:id',
    component: () => import('@/views/AIModule/chat/edit'),
    meta: {
      auth: true,
      title: i18n.t("lang.k_006004"),
      level: 2,
      name: 'AIChatEdit'
    },
    hidden: true
  }]
}];
export default router;